import OBase from './OBase';

import * as Geometry from '../geometry';

export default class LogN extends OBase {
  update () {
    let aValTree = this.getFloatInput('Number');
    let bValTree = this.getFloatInput('Base');
    var pOutput = this.getGenericObjectOutput('Result');

    var dataTrees = [];
    var outDataTrees = [];
    dataTrees.push(aValTree, bValTree);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    var outTree = new Geometry.DataTree();

    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        var aVal = outDataTrees[0].branches[i][j];
        var bVal = outDataTrees[1].branches[i][j];

        let val = logn(bVal, aVal);
        outTree.add(val, outDataTrees[0].paths[i]);
      }
    }

    pOutput.value = outTree;
  }
}

function logn (b, n) {
  return Math.log(n) / Math.log(b);
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/LogN.js